import { createCustomErrorClass } from "@ledgerhq/errors";
export var EthAppPleaseEnableContractData = createCustomErrorClass("EthAppPleaseEnableContractData");
export var EthAppNftNotSupported = createCustomErrorClass("EthAppNftNotSupported");
//# sourceMappingURL=errors.js.map